

import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"

import { cn } from "@/lib/utils"

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "vtwo:flex vtwo:items-center vtwo:gap-2 vtwo:text-sm vtwo:leading-none vtwo:font-medium vtwo:select-none vtwo:group-data-[disabled=true]:pointer-events-none vtwo:group-data-[disabled=true]:opacity-50 vtwo:peer-disabled:cursor-not-allowed vtwo:peer-disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Label }
